module.exports = __webpack_public_path__ + "img/9.b2dc64b9.png";